<template>
    <b-card no-body class="p-1">
        <div style="width: 100%" class="d-flex justify-content-center text-center my-5 mx-auto">
            <a target="_blank" href="https://raychat.io//admin/conversations?channelId=61dc1bc3ac0d51986c40407d#secret=5845910000&s=&limit=10&skip=1" class="btn btn-primary"> لینک ورود به رایچت </a>
        </div>
    </b-card>

</template>

<script>
export default {
    name: "Raychat"
}
</script>

<style scoped>

</style>